import { UrlApi } from "../../../services/apirest";
import Navbar from "../../Navbar";
import React, { useState, useEffect, useMemo } from "react";
import MaterialReactTable from "material-react-table";

import {
  // Componentes para los estilos
  Typography,
  IconButton,
  Box,
  Tooltip,
  Alert,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //idioma
import moment from "moment";
import Editarvianda from "./Editarvianda";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";

import BlockIcon from "@mui/icons-material/Block";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
//faltalog
function Tablaresumen(props) {
  const [mostrarAlerta, setMostrarAlerta] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("");
  //const [datospedidos, setDatospedidos] = useState(props.data);
  const [datospedidos, setDatospedidos] = useState([]);
  const [updatetabla, setUpdatetabla] = useState(false);
  //console.log("updatetabla", updatetabla);
  const [cantidadDEViandasMensuales, setCantidadDEViandasMensuales] =
    useState(0);

  const [modificaciones, setModificaciones] = useState(false);
  const [activar, setActivar] = useState(false);
  const [datosrow, setDatosrow] = useState([]); //datos para modificar
 // console.log("activar", activar);

  const mostrarAlertaTemporal = (mensaje, severidad) => {
    setMostrarAlerta(true);
    setMessage(mensaje);
    setSeverity(severidad);

    setTimeout(() => {
      setMostrarAlerta(false);
    }, 5000);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "fecha_dia",
        header: "Día",
        Cell: ({ row }) => {
          const rawFecha = row.original.fecha;
          return rawFecha ? moment(rawFecha).locale("es").format("dddd") : "-";
        },
        size: 80,
      },
      {
        accessorKey: "fecha",
        header: "Fecha",
        size: 120,
        Cell: ({ cell }) =>
          cell.getValue()
            ? new Date(cell.getValue()).toLocaleDateString("es-AR")
            : "-",
      },
      {
        accessorKey: "menu",
        header: "Menú",
        size: 100,
      },
      {
        accessorKey: "username",
        header: "Usuario",
        size: 120,
      },
      {
        accessorKey: "sucursal",
        header: "Sucursal",
        size: 140,
      },
    ],
    []
  );

  useEffect(() => {
    if (
      props.datosempleado &&
      props.datosempleado.usuario &&
      props.datosempleado.fechainicio
    ) {
      Recuperar();
    }
  }, [props.datosempleado]);

  const handleClose = () => {
    if (props.setMostrarResumen) {
      props.setMostrarResumen(false);
    }
  };

  //anterior por si acaso
  // const Recuperar = async () => {
  //   const { usuario, fechainicio } = props.datosempleado || {};

  //   if (!usuario || !fechainicio) {
  //     console.warn("Faltan datos para recuperar pedidos");
  //     return;
  //   }

  //   try {
  //     const response = await fetch(
  //       `${UrlApi}/viandas/pedidos/${usuario}/${fechainicio}`
  //     );
  //     const data = await response.json();
  //     setDatospedidos(data.data || []);
  //     console.log("Pedidos filtrados:", data);
  //     return data.data;
  //   } catch (error) {
  //     console.error("Error al recuperar pedidos filtrados:", error);
  //   }
  // };

  const Recuperar = async () => {
    const { usuario, fechainicio, fechafin } = props.datosempleado || {};

    if (!usuario || !fechainicio) {
      console.warn("Faltan datos para recuperar pedidos");
      return;
    }

    try {
      const response = await fetch(
        `${UrlApi}/viandas/pedidos?username=${usuario}&fechaInicio=${fechainicio}&fechaFin=${fechafin}`
      );
      const data = await response.json();
      const pedidos = Array.isArray(data?.data) ? data.data : [];
      setCantidadDEViandasMensuales(pedidos.length);
      setUpdatetabla(false); //para cuando llama al estado de actualizar se ponga en false
      // Ordenar por fecha (ajusta el campo "fecha" al nombre real del campo)
      const datosOrdenados = (data.data || []).sort((a, b) => {
        return new Date(a.fecha) - new Date(b.fecha); // Ascendente (más antiguo a más reciente)
      });

      setDatospedidos(datosOrdenados);
      //  console.log("Pedidos filtrados y ordenados:", datosOrdenados);
      return datosOrdenados;
    } catch (error) {
      console.error("Error al recuperar pedidos filtrados:", error);
    }
  };

  useEffect(() => {
    if (
      updatetabla &&
      props.datosempleado &&
      props.datosempleado.usuario &&
      props.datosempleado.fechainicio
    ) {
      Recuperar();
    }
  }, [updatetabla, props.datosempleado]);

  const { fechainicio, fechafin } = props.datosempleado;

  const handledesactivar = (row) => {
    setModificaciones(true);
    setDatosrow(row);
    console.log("row", row);
    setActivar(false);
  };

  const handleactivar = (row) => {
    setModificaciones(true);
    setDatosrow(row);
    console.log("row", row);
    setActivar(true);
  };

  const rrhh = localStorage.getItem("adminrrhh");
  return (
    <>
      {mostrarAlerta && (
        <Alert
          severity={severity}
          sx={{
            zIndex: 1600,
            position: "fixed",
            top: "20px",
            right: "20px",
            width: "auto",
            borderRadius: "8px",
            backgroundColor:
              severity === "success"
                ? "#d8e6d3"
                : severity === "error"
                ? "#efc3c3"
                : severity === "warning"
                ? "#f0efb6"
                : severity === "info"
                ? "#0a8ff5"
                : "#e6e6e6",
          }}
        >
          {message}
        </Alert>
      )}
      <Navbar />

      {datospedidos ? (
        <MaterialReactTable
          renderTopToolbarCustomActions={() => (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <IconButton onClick={handleClose}>
                <ArrowBackIcon sx={{ color: grey[900] }} />
              </IconButton>
              <Typography variant="h6">
                Pediste {cantidadDEViandasMensuales} viandas entre el{" "}
                {moment(fechainicio).format("DD/MM/YYYY")} y el{" "}
                {moment(fechafin).format("DD/MM/YYYY")}
              </Typography>
            </Box>
          )}
          initialState={{
            showGlobalFilter: true,
            density: "compact",
          }}
          renderRowActions={({ row, table }) =>
            rrhh === "1" && (
              <Box sx={{ display: "flex", gap: "1rem", alignItems: "center" }}>
                <Tooltip arrow placement="left" title="Desactivar">
                  <IconButton
                    color="error"
                    onClick={() => {
                      handledesactivar(row.original);
                    }}
                  >
                    <BlockIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip arrow placement="left" title="Activar">
                  <IconButton
                    color="success"
                    onClick={() => {
                      handleactivar(row.original);
                    }}
                  >
                    <CheckCircleIcon />
                  </IconButton>
                </Tooltip>
              </Box>
            )
          }
          positionActionsColumn="last" //first o last posicion de los accion elementos de la fila
          enableRowActions // habilitar acciones
          columns={columns}
          data={datospedidos}
          enableTopToolbar={true}
          enableColumnFilters={true}
          enableGlobalFilter={true}
          enableDensityToggle={false}
          localization={MRT_Localization_ES}
          muiTablePaperProps={{
            sx: {
              maxWidth: "lg", // puede ser 'md', 'lg' o 'xl'
              m: "auto",
              width: "100%", // opcional
            },
          }}
          muiTableBodyCellProps={({ row }) => ({
            align: "left",
            sx: {
              backgroundColor:
                row.original.activa === 0 ? "#efc3c3" : "#f5f5f5", // rojo claro para inactivo, color muy clarito para activo
            },
          })}
        />
      ) : null}

      {modificaciones ? (
        <Editarvianda
          mostrarAlertaTemporal={mostrarAlertaTemporal}
          data={datosrow}
          modificaciones={setModificaciones}
          updatetabla={setUpdatetabla}
          activar={activar}
          setActivar={setActivar}
        />
      ) : null}
    </>
  );
}

export default Tablaresumen;
